import React, { memo, useMemo } from 'react'
import times from 'lodash/times'
import Skeleton from 'transfix-ui/core/Skeleton'
import { makeStyles } from 'transfix-ui/core/styles'
import { TEST_IDS } from '../../constants'
import { IShipmentMissingInfoFragment } from '../../graphql/ShipmentMissingInfoFragment'
import ShipmentNeedingAttentionRow from '../ShipmentNeedingAttentionRow'
import ShipmentsNeedingAttentionEmpty from '../ShipmentsNeedingAttentionEmpty'

const useShipmentsNeedingAttentionRowsStyles = makeStyles(theme => ({
  rows: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),

    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(1.5),
    },
  },
  skeleton: {
    height: 93,
  },
}))

export interface IShipmentsNeedingAttentionRowsProps {
  /**
   * @default []
   */
  shipments: IShipmentMissingInfoFragment[]
  /**
   * @default false
   */
  loading?: boolean
}

const ShipmentsNeedingAttentionRows = memo<IShipmentsNeedingAttentionRowsProps>(
  ({ loading = false, shipments = [] }) => {
    const classes = useShipmentsNeedingAttentionRowsStyles()

    const isEmpty = useMemo(() => {
      return !loading && shipments.length <= 0
    }, [loading, shipments.length])

    const hasShipments = useMemo(() => {
      return !loading && shipments.length > 0
    }, [loading, shipments.length])

    return (
      <div>
        {loading && (
          <div className={classes.rows} data-test={TEST_IDS.loadingState}>
            {times(4).map(i => (
              <Skeleton key={i} variant='rectangular' className={classes.skeleton} />
            ))}
          </div>
        )}
        {hasShipments && (
          <div className={classes.rows}>
            {shipments.map(
              ({ id, marketplaceId, missingInfo, missingInfoUrgencyMessage, stops }) => (
                <ShipmentNeedingAttentionRow
                  key={id}
                  id={id}
                  marketplaceId={marketplaceId}
                  stops={stops}
                  missingInformation={missingInfo}
                  missingInfoMessage={missingInfoUrgencyMessage}
                />
              )
            )}
          </div>
        )}
        {isEmpty && <ShipmentsNeedingAttentionEmpty />}
      </div>
    )
  }
)

export default ShipmentsNeedingAttentionRows
